import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Link } from '../../custom_components/components/library/link';
import { LinkButton } from '../../custom_components/components/library/button';
import { trackActivityClick } from '../../custom_components/components/library/tracking';
import { pushNewsletterSubscription } from './datalayer';
const footerCopy = [
    [
        {
            label: 'Over ons',
            url: '/over-ons',
            dataTracker: ()=>trackActivityClick(window.location.pathname, 'Footer click')
        },
        {
            label: 'Werken bij',
            url: '/werken-bij',
            dataTracker: ()=>trackActivityClick(window.location.pathname, 'Footer click')
        },
        {
            label: 'Contact',
            url: '/klantenservice',
            dataTracker: ()=>trackActivityClick(window.location.pathname, 'Footer click')
        }
    ],
    [
        {
            label: 'Erasmus Online Database',
            url: '/eol',
            dataTracker: ()=>trackActivityClick(window.location.pathname, 'Footer click')
        },
        {
            label: 'De Nieuwe Centrale Bibliotheek',
            url: '/nieuwe-centrale-bibliotheek',
            dataTracker: ()=>trackActivityClick(window.location.pathname, 'Footer click')
        },
        {
            label: 'Stadsdichter',
            url: '/stadsdichter',
            dataTracker: ()=>trackActivityClick(window.location.pathname, 'Footer click')
        }
    ]
];
const footerTop = ()=>/*#__PURE__*/ _jsx("div", {
        className: "footer__top",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "footer__container container--full gutter--m align--center",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "footer__columns",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "footer__columns--group",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "footer__column",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "footer__inner",
                                    children: [
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "footer__title title--s",
                                            children: "Algemeen"
                                        }),
                                        footerCopy[0].map((item)=>/*#__PURE__*/ _jsx(Link, {
                                                className: "footer__link",
                                                url: item.url,
                                                handle: item.dataTracker,
                                                children: item.label
                                            }))
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "footer__column",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "footer__inner",
                                    children: [
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "footer__title title--s",
                                            children: "Snel naar"
                                        }),
                                        footerCopy[1].map((item)=>/*#__PURE__*/ _jsx(Link, {
                                                className: "footer__link",
                                                url: item.url,
                                                handle: item.dataTracker,
                                                children: item.label
                                            }))
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "footer__column",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "footer__inner",
                                    children: [
                                        /*#__PURE__*/ _jsx("p", {
                                            className: "footer__title title--s",
                                            children: "Nieuwsbrief"
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            children: "Schrijf je in voor onze nieuwsbrief en blijf op de hoogte van alle ontwikkelingen in de bibliotheek!"
                                        }),
                                        /*#__PURE__*/ _jsx(LinkButton, {
                                            className: "button_newsbrief",
                                            variant: "white",
                                            arrow: true,
                                            route: "https://www.bibliotheek.rotterdam.nl/wise-apps/opac/1099/subscription/newsletter",
                                            handle: ()=>pushNewsletterSubscription('Footer click'),
                                            children: /*#__PURE__*/ _jsx("span", {
                                                className: "button__label",
                                                children: "Schrijf je in"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("img", {
                    className: "footer__logo",
                    src: "/bkw/images/bkw/logo-aanzet.svg",
                    alt: "",
                    width: "131",
                    height: "128",
                    "aria-hidden": "true",
                    loading: "lazy"
                })
            ]
        })
    });
export default footerTop;
